const doc = [({"en":({"js":({"admin":({"contacts":({"edit":({"billing_contact":({"billing_information":"Billing information"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;